import { supabase } from "../supabase";

/** 詳細の情報パネルで出す1件分。一覧では引いていない列も含む */
export interface MediaMeta {
  id: string;
  type: "photo" | "video";
  mime_type: string;
  byte_size: number;
  width: number | null;
  height: number | null;
  duration_seconds: number | null;
  taken_at: string;
  uploaded_at: string;
  uploader_id: string;
}

const COLUMNS =
  "id, type, mime_type, byte_size, width, height, duration_seconds, taken_at, uploaded_at, uploader_id";

/** 情報パネルを開いたときだけ引く。一覧の取得を重くしないため別にしている */
export async function fetchMediaMeta(mediaId: string): Promise<MediaMeta> {
  const { data, error } = await supabase.from("media").select(COLUMNS).eq("id", mediaId).single();
  if (error) throw error;
  const meta: MediaMeta = data;
  return meta;
}

const MIME_LABELS: Record<string, string> = {
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "image/webp": "WebP",
  "image/heic": "HEIC",
  "image/heif": "HEIF",
  "video/mp4": "MP4",
  "video/quicktime": "MOV",
};

/** MIME を見慣れた呼び名にする。知らないものはそのまま出す */
export function formatMime(mime: string): string {
  return MIME_LABELS[mime.toLowerCase()] ?? mime;
}

/** 「4032 × 3024 (1219万画素)」の形。寸法が無い古い行は null を返す */
export function formatResolution(width: number | null, height: number | null): string | null {
  if (width === null || height === null) return null;
  const man = Math.round((width * height) / 10_000);
  return `${String(width)} × ${String(height)} (${String(man)}万画素)`;
}
